import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import img1 from "../../assets/images/small/img-1.jpg";
import img2 from "../../assets/images/small/img-2.jpg";
import img3 from "../../assets/images/small/img-6.jpg";
import { FiSend } from "react-icons/fi"; // Import the paper plane icon
import Footer from "components/VerticalLayout/Footer";

const Webstories = () => {
    const navigate = useNavigate();
    const location = useLocation();

    // Stories array with directly referenced images
    const stories = [
        { id: 1, img: img1, title: "Story 1" },
        { id: 2, img: img3, title: "Story 2" },
        { id: 3, img: img1, title: "Story 3" },
        { id: 4, img: img3, title: "Story 4" },
        { id: 5, img: img1, title: "Story 5" },
    ];

    const [currentStory, setCurrentStory] = useState(0);
    const [isPaused, setIsPaused] = useState(false);
    const [isFullscreen, setIsFullscreen] = useState(false);

    // Autoplay logic
    useEffect(() => {
        if (!isPaused) {
            const timer = setInterval(() => {
                setCurrentStory((prev) => (prev + 1) % stories.length);
            }, 5000); // Change story every 5 seconds
            return () => clearInterval(timer);
        }
    }, [isPaused, currentStory, stories.length]);

    useEffect(() => {
        // Detect if URL matches fullscreen route and set fullscreen accordingly
        if (location.pathname === "/blog/flats-&-appartments-in-vadodara-at-affordable-price") {
            setIsFullscreen(true);
        }
    }, [location.pathname]);

    const handleNext = () => {
        setCurrentStory((prev) => (prev + 1) % stories.length);
    };

    const handlePrev = () => {
        setCurrentStory((prev) => (prev - 1 + stories.length) % stories.length);
    };

    const openFullscreen = () => {
        setIsFullscreen(true);
        navigate("/blog/flats-&-appartments-in-vadodara-at-affordable-price"); // Update URL
    };

    const closeFullscreen = () => {
        setIsFullscreen(false);
        navigate("/blog"); // Reset URL to home or desired non-fullscreen route
    };

    return (
        <div>
            {/* Normal Story View */}
            <div
                style={{
                    position: "relative",
                    width: "100%",
                    maxWidth: "400px",
                    height: "460px",
                    margin: "auto",
                    overflow: "hidden",
                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.4)",
                    backgroundColor: "#1E253A",
                    cursor: "pointer",
                }}
                onClick={openFullscreen} // Open fullscreen on click
            >
                {/* Story Image */}
                <img
                    src={stories[currentStory].img}
                    alt={stories[currentStory].title}
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                    }}
                    onMouseEnter={() => setIsPaused(true)}
                    onMouseLeave={() => setIsPaused(false)}
                />
                {/* Progress Indicators */}
                <div
                    style={{
                        position: "absolute",
                        top: "10px",
                        left: "10px",
                        right: "10px",
                        display: "flex",
                        gap: "5px",
                    }}
                >
                    {stories.map((story, index) => (
                        <div
                            key={story.id}
                            style={{
                                flex: 1,
                                height: "4px",
                                backgroundColor:
                                    currentStory === index ? "white" : "rgba(255, 255, 255, 0.5)",
                                transition: "all 0.3s ease",
                            }}
                        />
                    ))}
                </div>
            </div>

            {/* Fullscreen Story Modal */}


            {isFullscreen && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0, 0, 0, 0.9)",
                        zIndex: 9999,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <div
                        style={{
                            position: "relative",
                            width: "100%",
                            maxWidth: "800px",
                            height: "100%",
                            overflow: "hidden",
                        }}
                    >
                        <img
                            src={stories[currentStory].img}
                            alt={stories[currentStory].title}
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                            }}
                        />
                        {/* Close Button */}
                        <button
                            onClick={closeFullscreen}
                            style={{
                                position: "absolute",
                                top: "20px",
                                right: "20px",
                                backgroundColor: "transparent",
                                color: "white",
                                border: "none",
                                fontSize: "24px",
                                cursor: "pointer",
                            }}
                        >
                            &times;
                        </button>
                        {/* Navigation Buttons */}
                        <button
                            onClick={handlePrev}
                            style={{
                                position: "absolute",
                                left: "20px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                backgroundColor: "transparent",
                                color: "white",
                                border: "none",
                                fontSize: "24px",
                                cursor: "pointer",
                            }}
                        >
                            &#8249;
                        </button>
                        <button
                            onClick={handleNext}
                            style={{
                                position: "absolute",
                                right: "20px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                backgroundColor: "transparent",
                                color: "white",
                                border: "none",
                                fontSize: "24px",
                                cursor: "pointer",
                            }}
                        >
                            &#8250;
                        </button>
                        {/* Share Button */}
                        <button
                            onClick={() => {
                                const shareURL = `${window.location.origin}/what-is-jantri?story=${stories[currentStory].id}`;
                                const shareData = {
                                    title: stories[currentStory].title,
                                    text: `Check out this story: ${stories[currentStory].title}`,
                                    url: shareURL,
                                };

                                // Check if Web Share API is supported
                                if (navigator.share) {
                                    navigator
                                        .share(shareData)
                                        .then(() => console.log("Story shared successfully"))
                                        .catch((error) => console.error("Error sharing story:", error));
                                } else {
                                    alert("Sharing is not supported in your browser. Please copy the link manually.");
                                }
                            }}
                            style={{
                                position: "absolute",
                                bottom: "20px",
                                right: "20px",
                                backgroundColor: "rgba(255, 255, 255, 0.1)",
                                color: "white",
                                border: "none",
                                padding: "12px",
                                borderRadius: "50%",
                                fontSize: "20px",
                                cursor: "pointer",
                                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.5)",
                            }}
                            title="Share Story"
                        >
                            <FiSend size={24} />
                        </button>

                        {/* Progress Indicators */}
                        <div
                            style={{
                                position: "absolute",
                                top: "10px",
                                left: "10px",
                                right: "10px",
                                display: "flex",
                                gap: "5px",
                            }}
                        >
                            {stories.map((story, index) => (
                                <div
                                    key={story.id}
                                    style={{
                                        flex: 1,
                                        height: "4px",
                                        backgroundColor:
                                            currentStory === index ? "white" : "rgba(255, 255, 255, 0.5)",
                                        transition: "all 0.3s ease",
                                    }}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            )}
            {/* Footer */}
            <Footer />
        </div>
    );
};

export default Webstories;

